module.exports = __webpack_public_path__ + "static/img/player_head_16.b7e1d01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_16.jpg
// module id = NGv5
// module chunks = 1